import React from 'react';
import { ApiOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { DOCS_URL } from '../../../../constants/app';

import { StyledCard } from './style';

const ApiCard = () => (
  <StyledCard bordered={false} title="API Documentation">
    <p>
      Your API key includes all endpoints shown in Studio, giving you direct access to a wide range of assets and
      on-chain metrics.
    </p>

    <Button block href={DOCS_URL} icon={<ApiOutlined />} rel="noopener noreferrer" target="_blank" type="dashed">
      View API Documentation
    </Button>
  </StyledCard>
);

export default ApiCard;
